import React, { useState } from "react";

import { TextField } from "@aclymatepackages/atoms";
import { numbersRegExpTest } from "@aclymatepackages/reg-exp";

import CompanyDataListItem from "./CompanyDataListItem";
import { useCachedFirebaseCrud } from "../../../helpers/firebase";

const CompanyEmployeeCountRow = ({ employeeCount }) => {
  const { updateAccountData } = useCachedFirebaseCrud();

  const [modifyEmployeeCount, setModifyEmployeeCount] = useState(employeeCount);
  const [isModified, setIsModified] = useState(false);

  const isError =
    !modifyEmployeeCount || !numbersRegExpTest(modifyEmployeeCount);

  return (
    <CompanyDataListItem
      editingComponent={
        <TextField
          value={modifyEmployeeCount}
          setValue={(newValue) => {
            setModifyEmployeeCount(newValue);
            setIsModified(true);
          }}
          variant="standard"
          label="Edit Employee Count"
          InputProps={{ style: { width: "250px" } }}
          helperText={isError && "Your employee count must be a whole number"}
          error={isError}
        />
      }
      saveDisabled={isError}
      onCancel={() => {
        setIsModified(false);
        setModifyEmployeeCount(employeeCount);
      }}
      onSave={() => {
        setIsModified(false);
        updateAccountData({ employeeCount: modifyEmployeeCount });
      }}
      primaryText={employeeCount}
      secondaryText="Number of Employees"
      isTextField={true}
      isUpdated={isModified}
    />
  );
};
export default CompanyEmployeeCountRow;
